import cx from 'classnames'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { Logs as LogsIcon, SettingsCog as SettingsCogIcon } from 'common/icons'
import {
  getContentHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'

import { ActivePanel, HandleActivePanelChange } from './RightSection'

type Props = {
  activePanel: ActivePanel | undefined
  integrationTitle?: string
  handleActivePanelChange: HandleActivePanelChange
}

const CollapsedIcons = ({
  integrationTitle,
  activePanel,
  handleActivePanelChange,
}: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()
  const isOptimized = getIsOptimized(selectedElement)

  const commonClassName = 'cursor-pointer hover:text-gold-700'
  const hasVariants = getContentHasVariants(content)

  return (
    <>
      {isOptimized && (
        <ButtonWithTooltip
          data-testid="campaignLogs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="top"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'campaignLogs',
                'text-gold-600 ': activePanel !== 'campaignLogs',
              })}
            />
          }
          onClick={() => handleActivePanelChange('campaignLogs')}
        />
      )}
      {selectedElement && hasVariants && (
        <div className="flex items-stretch">
          <ExportMenuButton tooltipPlacement="top" />
        </div>
      )}
      {isOptimized && integrationTitle && (
        <ButtonWithTooltip
          data-testid="optimizeIntegration-sidebar-button"
          variant="icon"
          tooltip
          tooltipText={integrationTitle}
          placement="top"
          prefixIcon={
            <SettingsCogIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'optimizeIntegration',
                'text-gold-600 ': activePanel !== 'optimizeIntegration',
              })}
            />
          }
          onClick={() => handleActivePanelChange('optimizeIntegration')}
        />
      )}
      {!isOptimized && (
        <ButtonWithTooltip
          data-testid="integrationLogs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="top"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'integrationLogs',
                'text-gold-600 ': activePanel !== 'integrationLogs',
              })}
            />
          }
          onClick={() => handleActivePanelChange('integrationLogs')}
        />
      )}
    </>
  )
}

export default CollapsedIcons
